import React from "react";
import { useParams } from "react-router";
import { useQuery } from "@apollo/client";
import { GET_APPEARANCE } from "../../GraphQL/Appearances.js";
import LoadingSpinner from "../../Components/UI/LoadingSpinner.js";
import PageError from "../../Components/UI/PageError.js";
import PageLayout from "../../Components/UI/PageLayout.js";
import { Grid, Paper, Typography, Box } from "@mui/material";
import PlayerButton from "../../Components/Player/PlayerButton.js";
import TeamButton from "../../Components/Team/TeamButton.js";
import MatchButton from "../../Components/Match/MatchButton.js";

const AppearancePage = () => {
  const { appearanceId } = useParams();

  const appearance = useQuery(GET_APPEARANCE, {
    variables: { id: appearanceId },
  });

  if (appearance.error) {
    return (
      <PageError
        message={appearance.error.message}
        onRetry={() => appearance.refetch()}
      />
    );
  }

  if (appearance.loading) return <LoadingSpinner />;

  return (
    <PageLayout
      title="Appearance"
      breadcrumbs={[
        { label: "Home", to: "/" },
        {
          label: appearance.data.appearance.player.name,
          to: "/player/" + appearance.data.appearance.player.id,
        },
        { label: "Appearance" },
      ]}
    >
      <Grid container spacing={2}>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}>
          <PlayerButton
            playerId={appearance.data.appearance.player.id}
          />
        </Grid>
        <Grid item xs={2}>
          <MatchButton matchId={appearance.data.appearance.match.id} />
        </Grid>
        <Grid item xs={2}>
          <TeamButton team={appearance.data.appearance.team} />
        </Grid>
        <Grid item xs={3}></Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={3}></Grid>
        <Grid item xs={6}>
          <Paper
            sx={{
              p: 3,
              backgroundColor: "#333333",
              borderLeft: "4px solid #14b8a6",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6" sx={{ color: "#14b8a6", fontWeight: "600", marginBottom: "16px" }}>
                  Match Statistics
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ marginBottom: "12px" }}>
                  <Typography variant="body2" sx={{ color: "#999999", fontSize: "12px" }}>
                    Player
                  </Typography>
                  <Typography variant="body1" sx={{ color: "white" }}>
                    {appearance.data.appearance.player.name}
                  </Typography>
                </Box>
                <Box sx={{ marginBottom: "12px" }}>
                  <Typography variant="body2" sx={{ color: "#999999", fontSize: "12px" }}>
                    Team
                  </Typography>
                  <Typography variant="body1" sx={{ color: "white" }}>
                    {appearance.data.appearance.team.name}
                  </Typography>
                </Box>
                <Box sx={{ marginBottom: "12px" }}>
                  <Typography variant="body2" sx={{ color: "#999999", fontSize: "12px" }}>
                    Home Team
                  </Typography>
                  <Typography variant="body1" sx={{ color: "white" }}>
                    {appearance.data.appearance.match.homeTeam.name}
                  </Typography>
                </Box>
                <Box sx={{ marginBottom: "12px" }}>
                  <Typography variant="body2" sx={{ color: "#999999", fontSize: "12px" }}>
                    Away Team
                  </Typography>
                  <Typography variant="body1" sx={{ color: "white" }}>
                    {appearance.data.appearance.match.awayTeam.name}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ marginBottom: "12px" }}>
                  <Typography variant="body2" sx={{ color: "#999999", fontSize: "12px" }}>
                    Goals
                  </Typography>
                  <Typography variant="body1" sx={{ color: "#14b8a6", fontWeight: "600" }}>
                    {appearance.data.appearance.goals}
                  </Typography>
                </Box>
                <Box sx={{ marginBottom: "12px" }}>
                  <Typography variant="body2" sx={{ color: "#999999", fontSize: "12px" }}>
                    Assists
                  </Typography>
                  <Typography variant="body1" sx={{ color: "#14b8a6", fontWeight: "600" }}>
                    {appearance.data.appearance.assists}
                  </Typography>
                </Box>
                <Box sx={{ marginBottom: "12px" }}>
                  <Typography variant="body2" sx={{ color: "#999999", fontSize: "12px" }}>
                    Passes
                  </Typography>
                  <Typography variant="body1" sx={{ color: "white" }}>
                    {appearance.data.appearance.passes}
                  </Typography>
                </Box>
                <Box sx={{ marginBottom: "12px" }}>
                  <Typography variant="body2" sx={{ color: "#999999", fontSize: "12px" }}>
                    Interceptions
                  </Typography>
                  <Typography variant="body1" sx={{ color: "white" }}>
                    {appearance.data.appearance.interceptions}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ borderTop: "1px solid #444444", paddingTop: "16px", marginTop: "8px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Box>
                        <Typography variant="body2" sx={{ color: "#999999", fontSize: "12px" }}>
                          Tackles
                        </Typography>
                        <Typography variant="body1" sx={{ color: "white" }}>
                          {appearance.data.appearance.tackles}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box>
                        <Typography variant="body2" sx={{ color: "#999999", fontSize: "12px" }}>
                          Yellow Cards
                        </Typography>
                        <Typography variant="body1" sx={{ color: "#fbbf24" }}>
                          {appearance.data.appearance.yellowCards}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box>
                        <Typography variant="body2" sx={{ color: "#999999", fontSize: "12px" }}>
                          Red Cards
                        </Typography>
                        <Typography variant="body1" sx={{ color: "#ef4444" }}>
                          {appearance.data.appearance.redCards}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={3}></Grid>
      </Grid>
    </PageLayout>
  );
};

export default AppearancePage;
